import React from "react";
import { NavLink } from "react-router-dom";
import { IoSettingsOutline, IoPersonOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { MdOutlineDashboard, MdOutlineAccessTime } from "react-icons/md"; // Add this import

function BottomNavBar() {
  const navLinks = [
    {name: "Dashboard", link: "/admin/dashboard", icon: <MdOutlineDashboard />,},
    {name: "Employees", link: "/admin/employees", icon: <IoPersonOutline /> },
    { name: "Attendance", link: "/admin/attendance", icon: <MdOutlineAccessTime />, }, // Added attendance
    { name: "Events", link: "/admin/events", icon: <SlCalender /> },
    { name: "Settings", link: "/admin/settings", icon: <IoSettingsOutline /> },
  ];

  return (
    <div className="flex justify-around items-center px-1 py-2 h-full bg-slate-800 shadow-lg">
      {navLinks.map((item, index) => (
        <NavLink
          key={index}
          to={item.link}
          className={({ isActive }) =>
            `flex flex-col items-center p-1.5 rounded-lg transition-colors
            ${
              isActive
                ? "text-white bg-slate-700"
                : "text-gray-400 hover:text-white"
            }`
          }
        >
          <span className="text-lg">{item.icon}</span>
          <span className="text-[10px] mt-0.5">{item.name}</span>
        </NavLink>
      ))}
    </div>
  );
}

export default BottomNavBar;
